import { useState } from 'react';

import {
  Modal,
  Paper,
  TextField,
  Grid,
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
} from '@mui/material';

import { Store } from 'types';

type Props = {
  open: boolean;
  handleOpen: () => void;
  onCreate: (newStore: Store) => void;
};

export default function AddStoreModal({
  open = true,
  handleOpen,
  onCreate,
}: Props) {
  const defaultValues: Omit<Store, 'id'> = {
    code: '',
    description: '',
    is_active: true,
  };

  const [data, setData] = useState<Omit<Store, 'id'>>(defaultValues);

  const handleChange = (name: string, value: any) => {
    setData({
      ...data,
      [name]: value,
    });
  };

  const onSubmit = (newStore: Omit<Store, 'id'>) => {
    onCreate(newStore as Store);
  };

  return (
    <Modal open={open} onClose={handleOpen}>
      <Paper
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { sm: '90%', md: '30rem' },
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
        }}
      >
        <Grid container spacing={2}>
          <Typography variant='h5' gutterBottom>
            Nuevo Almacén
          </Typography>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              label='Código'
              fullWidth
              onChange={e => handleChange('code', e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={data.is_active}
                  onChange={(e) => handleChange("is_active", e.target.checked)}
                  color="primary"
                />
              }
              label="Almacén activo"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label='Descripción'
              fullWidth
              onChange={e => handleChange('description', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} display='flex' justifyContent='end' gap={1}>
            <Button
              type='button'
              variant='outlined'
              onClick={() => {
                setData(defaultValues);
                handleOpen();
              }}
            >
              Cancelar
            </Button>
            <Button
              type='submit'
              variant='contained'
              onClick={() => {
                onSubmit(data);
                setData(defaultValues);
                handleOpen();
              }}
            >
              Guardar
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Modal>
  );
}
